interface LoadingScreenProps {
  message?: string;
}

export function LoadingScreen({ message = 'LOADING ROMULUS...' }: LoadingScreenProps) {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#000000' }}>
      <div className="flex flex-col items-center gap-8">
        <div className="relative flex items-center justify-center">
          <div className="absolute w-32 h-32 rounded-full border-4 border-white/15 border-t-white animate-spin" />
          <div className="w-20 h-20 rounded-lg border-2 border-white bg-black flex items-center justify-center overflow-hidden">
            <img src="/wolfromulus.png" alt="Romulus" className="w-16 h-16 object-contain" />
          </div>
        </div>
        <p className="text-white font-sans font-bold text-lg">{message}</p>
      </div>
    </div>
  );
}
